/**
 * Id del landmark `<main>` de la pantalla: destino del skip link (TAN-8654) y de `useRouteFocusHandler`
 * (TAN-9802). Vive aquí y no en `core/layout` porque las páginas por capas no importan de `core`
 * (`src/shared/AGENTS.md`, DEU-55); `core/layout/constants` lo reexporta para el código viejo.
 */
export const MAIN_CONTENT_ID = 'main-content';
